import React, { createContext, useContext, useEffect, useState } from 'react';

interface ViewportContextType {
  viewPortWidth: number;
  viewPortHeight: number;
}

const ViewportContext = createContext<ViewportContextType | null>(null);

export const ViewportProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [viewPortWidth, setWidth] = useState(window.innerWidth);
  const [viewPortHeight, setHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setHeight(window.innerHeight);
      setWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <ViewportContext.Provider value={{ viewPortWidth, viewPortHeight }}>
      {children}
    </ViewportContext.Provider>
  );
};

export const useViewport = () => {
  const context = useContext(ViewportContext);
  if (!context) {
    throw new Error('useViewport must be used within a ViewportProvider');
  }
  return context;
};
